import { render, staticRenderFns } from "./Listing.vue?vue&type=template&id=2c85bd53&scoped=true&"
import script from "./Listing.vue?vue&type=script&lang=js&"
export * from "./Listing.vue?vue&type=script&lang=js&"
import style0 from "./Listing.vue?vue&type=style&index=0&id=2c85bd53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85bd53",
  null
  
)

export default component.exports